import { Injectable } from '@angular/core';
import { HttpService } from '@core/services';
import { Country } from '@shared/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MiscService {
  constructor(private httpService: HttpService) {}

  getCountries(): Observable<Country[]> {
    return this.httpService.get('/public/Misc/countries');
  }
}
